import styled from "styled-components";

export const ConfirmPopupContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-height: 290px;
  height: fit-content;
  width: 479px;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 1001;
  background: #ffffff;
`;

export const PopupContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  z-index: 1;
`;

export const PopupEmotion = styled.div`
  width: 91px;
  min-width: 91px;
  height: 63px;
  min-height: 63px;
  position: relative;
  z-index: 2;

  &::after {
    /* Character */

    content: "";
    position: absolute;
    width: 90px;
    height: 75px;
    left: -1px;
    top: -8px;
    background-image: url(/images/character-emotions/${({
      $characterEmotion,
    }) => $characterEmotion}.svg);

    z-index: 0;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
`;

export const Image = styled.img`
  width: ${({ $imageStyle }) =>
    $imageStyle?.width ? $imageStyle?.width : "71px"};
  min-width: ${({ $imageStyle }) =>
    $imageStyle?.width ? $imageStyle?.width : "71px"};
  height: ${({ $imageStyle }) =>
    $imageStyle?.height ? $imageStyle?.height : "71px"};
  min-height: ${({ $imageStyle }) =>
    $imageStyle?.height ? $imageStyle?.height : "71px"};
  z-index: 2;
`;

export const PopupTitle = styled.div`
  width: ${({ $width }) => $width || "100%"};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 31px;
  text-align: center;
  color: ${({ $titleStyle }) => $titleStyle?.fontColor || "#1d1d1de5"};
`;

export const PopupDescription = styled.div`
  width: ${({ $width }) => $width || "100%"};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #1d1d1d80;
  word-break: break-word;
  white-space: pre-wrap;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(29, 29, 29, 0.5);
  z-index: 1000;
`;
